/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import SidebarNavView from '@/views/SidebarNavView';
import { userHasRole } from '@/util/RoleUtils';

import './IntDashboardSidebarNavView.css';
import tmplIntDashboardSidebarNavView from './IntDashboardSidebarNavView.hbs';

const IntDashboardSidebarNavView = SidebarNavView.extend({
  template: tmplIntDashboardSidebarNavView,

  className: 'side-bar-nav-view int-dashboard-sidebar-nav-view',

  templateContext() {
    const isEPCUser = userHasRole('EPC');
    const isCRSUser = userHasRole('CRS');
    const isAdmin = userHasRole('Admin');
    const isAny = isEPCUser || isCRSUser || isAdmin;

    return {
      isEPCUser,
      isCRSUser,
      isAdmin,
      isAny,
      isLocalEnvironment: ENVIRONMENT === 'local.int'
    };
  },

  onRender() {
    const mode = this.options.mode;
    this.$el.find(`a[href="#${mode}"]`).addClass('active');
  }
});

export default IntDashboardSidebarNavView;
